<!-- Responsibility: Manage tester access and grants.
Scope: View-only card for admin tester grants state. -->
<admin-tester-card>
  <section class="admin-card">
    <header>
      <h2>Tester Access</h2>
      <button type="button" class="action-btn subtle" onclick={ () => openModal() }>GRANT ACCESS</button>
    </header>
    <p class="admin-copy">Grant invite-only access without pretending public checkout exists. Use plan grants for broad access, world grants for paid marketplace entries, and offer grants for curated preforged realities.</p>
    
    <ul class="admin-roster">
      <li each={ grant in props.testerGrants }>
        <div class="admin-roster-copy">
          <strong>{ props.principalName(grant) }</strong>
          <span>{ props.principalHandle(grant) }</span>
        </div>
        <div class="admin-roster-meta">
          <small>{ props.testerGrantLabel(grant) }</small>
          <small>{ grant.updatedAtMs ? `Updated ${props.formatTime(grant.updatedAtMs)}` : 'Imported grant' }</small>
        </div>
        <div class="admin-actions compact">
          <button type="button" class="action-btn subtle" onclick={ () => editGrant(grant) }>EDIT</button>
          <button type="button" class="action-btn subtle" onclick={ () => props.onRevokeTesterGrant(grant) }>REVOKE</button>
        </div>
      </li>
    </ul>

    <dialog ref="testerModal" class="admin-form-modal">
      <div class="admin-modal-content">
        <header>
          <h3>Manage Tester Grant</h3>
          <button type="button" class="modal-close-hit" onclick={ closeModal }>✕</button>
        </header>
        <div ref="testerHost" class="admin-form-host"></div>
        <div class="admin-actions">
          <button type="button" class="action-btn primary" onclick={ saveGrant }>SAVE GRANT</button>
          <button type="button" class="action-btn" onclick={ resetForm }>RESET</button>
        </div>
      </div>
    </dialog>
  </section>

  <script>
    import { AutoForm, collectValues, populateFields } from 'field-assist'
    import { adminService } from '../../../services/admin-service.ts'
    import {
      buildAdminTesterInitialValues,
      buildAdminTesterFormMeta,
      buildAdminTesterSubmission,
    } from '../../helpers/admin-tester-form.ts'

    export default {
      editGrant(grant) {
        this.renderTesterForm(grant)
        this.openModal()
      },

      renderTesterForm(grant = {}) {
        const host = this.$('[ref="testerHost"]')
        if (!(host instanceof HTMLElement)) return
        host.replaceChildren()
        const initialValues = buildAdminTesterInitialValues(grant)
        const autoForm = new AutoForm(buildAdminTesterFormMeta())
        autoForm.render(initialValues, host)
        populateFields(host, initialValues, 'name')
      },

      openModal() {
        const modal = this.$('[ref="testerModal"]')
        if (modal instanceof HTMLDialogElement) modal.showModal()
      },

      closeModal() {
        const modal = this.$('[ref="testerModal"]')
        if (modal instanceof HTMLDialogElement) modal.close()
      },

      async saveGrant() {
        const host = this.$('[ref="testerHost"]')
        if (!(host instanceof HTMLElement)) return
        const values = collectValues(host, undefined, 'name')
        const submission = buildAdminTesterSubmission(values)
        await adminService.saveTesterGrant(submission)
        this.closeModal()
      },

      resetForm() {
        this.renderTesterForm()
      }
    }
  </script>

  <style>
    .admin-card {
      display: grid;
      gap: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 46%, transparent);
      border-radius: 1rem;
      padding: var(--space-md);
      background: var(--surface-raised);
      box-shadow: var(--shadow-elev-2);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: var(--space-sm);
    }

    h2 {
      margin: 0;
      color: var(--text-prose);
    }

    .admin-copy {
      color: var(--text-muted);
      font-size: var(--type-sm);
      margin: 0;
    }

    .admin-roster {
      display: grid;
      gap: var(--space-sm);
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .admin-roster li {
      display: grid;
      gap: var(--space-xs);
      padding: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 28%, transparent);
      border-radius: 0.5rem;
      background: color-mix(in srgb, var(--bg) 40%, transparent);
    }

    .admin-roster-copy {
      display: flex;
      flex-direction: column;
    }

    .admin-roster-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: var(--type-xs);
      color: var(--text-muted);
    }

    .admin-actions.compact {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-xs);
      margin-top: var(--space-xs);
    }

    .admin-form-modal {
      background: var(--surface-raised);
      border: 1px solid var(--border);
      border-radius: 1rem;
      color: var(--text-prose);
      padding: 0;
      max-width: 31.25rem;
      width: 90vw;
    }

    .admin-modal-content {
      padding: var(--space-lg);
      display: grid;
      gap: var(--space-md);
    }

    .modal-close-hit {
      background: none;
      border: none;
      color: var(--text-muted);
      cursor: pointer;
      font-size: 1.5rem;
    }
  </style>
</admin-tester-card>
